<template>
  <div class="inlay pb-12" :class="{'isNewInlay':inlay.isTop || inlay.isNew}">
    <div @click="focusInlay" class="image">
      <div v-if="inlay.isNew" class="new__balloon  flex float-right justify-center text-center"><p
        class="transform -rotate-45">New</p></div>
      <div v-if="inlay.isTop" class="new__balloon flex float-right justify-center text-center"><p
        class="transform -rotate-45">Top</p></div>
      <img v-if="inlay.thumbnail" :src="inlay.thumbnail" alt="thumbnail"
           class="border-2 border-classen__secondary">
      <img v-else src="../../../../assets/media/NoImage.png" alt="no image">
    </div>

    <div @click="focusInlay" class="mb-1 grid grid-cols-10">
      <p class="font-bold name col-span-8 text-left">{{ inlay.name }} </p>
    </div>

  </div>
</template>

<script>
import EventBus from "../../../../services/EventBus";
import getTranslation from "../../../../mixins/getTranslation";

export default {
  name: "InlayView",

  mixins: [getTranslation],

  components: {},

  props: {
    inlay: {required: true, type: Object}
  },

  data() {
    return {}
  },

  created() {

  },

  destroyed() {

  },

  computed: {},

  watch: {},

  methods: {
    focusInlay(e) {
      EventBus.fire('set-active_packaging', this.inlay)
    }
  }
}
</script>

<style scoped>
.inlay {
  width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.isNewInlay {
  margin-top: -40px;
}

img {
  width: 300px;
  height: 195px;
  object-fit: contain;
  border-radius: 35px 0 35px 0;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* number of lines to show */
}

.selection {
  position: relative;
  top: -55px;
}

.raise {
  margin-top: -40px;
}
</style>
